<!-- <div class="bg-gray-50 min-h-screen pt-24 pb-16 lg:pt-12"> -->
<div [ngClass]="isGuestView ? 'max-w-5xl mx-auto' : 'px-4 lg:px-0'">
  <div class="page-container">
    <div class="relative page-edge-cut">
      <div class="form-card">
        @if (caseDetailLoading) {
          <app-skeleton-loader
            [formLoader]="true"
            [noOfFields]="7"
          ></app-skeleton-loader>
        }
        <!-- Error Message -->
        @if (technicalErrorMsg) {
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'VALIDATION_MSG.ERROR' | translate,
              message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate,
            }"
            [showbutton]="false"
          ></app-validation-message>
        }
        @if (!caseDetailLoading && caseMeta.srNumber) {
          <!--UnRead Message Notification -->
          @if (hasUnreadMessages) {
            <app-validation-message
              [type]="'warning'"
              [content]="{
                title: ('CASE.NEW_MESSAGE_TITLE' | translate),
                message: ('CASE.NEW_MESSAGE_DESC' | translate),
              }"
              [showbutton]="false"
              [buttonText]="'CASE.VIEW_MESSAGE' | translate"
              (onBtnClick)="gotoNotesSection()"
            ></app-validation-message>
          }
          <!-- Complaint Details -->
          <section class="mt-10">
            <h1 class="section-heading">
              {{ "CASE.COMPLAINT_DETAILS" | translate }}
            </h1>

            <div class="fields-container">
              <div class="field-control">
                <table class="dc-table w-full text-sm text-dc-navy!">
                  <tbody>
                    @for (row of caseRows; track $index) {
                      <tr>
                        <td class="py-2 font-medium min-w-2xs">
                          <span class="text-dc-black">
                            {{ row.label | translate }}
                          </span>
                        </td>
                        <td class="py-2">
                          @if (row.label == "CASE.CREATED_DATE") {
                            {{ row.value() | date: "dd/MM/yyyy" }}
                          } @else {
                            {{ row.value() || "-" }}
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              @if (isRespondant) {
                <p
                  class="text-base! text-dc-navy! leading-relaxed text-justify mb-4"
                  [innerHTML]="
                    'CASE.COMPLAINANT_DETAIL'
                      | translate: { complaintName: complaintName }
                  "
                ></p>
              }
            </div>
          </section>

          <!-- Message History -->
          @if (this.messageHistory && this.messageHistory.length > 0) {
            <section #notesSection id="message-history" class="mt-12">
              <h1 class="section-heading">
                {{ "CASE.MESSAGE_HISTORY" | translate }}
              </h1>

              <div class="fields-container">
                <div class="field-control">
                  @for (message of visibleMessages; track $index) {
                    <div class="border-b-2 border-gray-200 pb-4 mb-4">
                      <div class="flex items-center gap-3">
                        <div>
                          <img src="/icons/svg/case-comment.svg" />
                        </div>
                        <div>
                          <p class="text-dc-navy font-semibold">
                            {{ message.author }}
                          </p>
                        </div>
                      </div>
                      <p class="text-xs text-dc-black!">
                        {{ message.timestamp | date: "dd MMM yyyy hh:mm a" }}
                      </p>
                      <p
                        class="text-sm leading-relaxed text-dc-navy! text-justify"
                      >
                        {{ message.body }}
                      </p>
                      @if (
                        $first && messageHistory.length > 1 && !showAllMessages
                      ) {
                        <button
                          type="button"
                          (click)="expandMessages()"
                          class="inline-block mt-3 text-sm text-dc-navy underline underline-offset-4"
                          [disabled]="markingAsRead"
                        >
                          {{ "CASE.SEE_PREVIOUS_MESSAGES" | translate }}
                        </button>
                      }
                    </div>
                  }
                </div>
              </div>
            </section>
          }
          <!-- Send Response -->
          <section class="mt-12">
            <h1 class="section-heading">
              {{ "CASE.SEND_RESPONSE" | translate }}
            </h1>

            <form [formGroup]="responseForm" class="space-y-4">
              @if (!responseSubmitted) {
                <div class="fields-container">
                  <div class="field-control">
                    <app-text-field
                      [label]="'CASE.YOUR_MESSAGE' | translate"
                      [control]="responseForm.get('response')!"
                      [placeholder]="'CASE.MESSAGE_PH' | translate"
                      [type]="'big-text'"
                      [maxlength]="4000"
                      [rows]="4"
                    ></app-text-field>
                  </div>
                </div>
                @if (showActions) {
                  <div class="fields-container">
                    <div class="field-control">
                      @if (!noteSubmitting) {
                        <app-button
                          type="button"
                          classesName="btn-edge-cut btn-width-auto"
                          [label]="'CASE.SEND' | translate"
                          (onBtnClick)="submitResponse()"
                        ></app-button>
                      }
                      @if (noteSubmitting) {
                        <app-button
                          type="button"
                          classesName="btn-edge-cut btn-width-auto"
                          [label]="'PLEASE_WAIT' | translate"
                          [disabled]="true"
                        ></app-button>
                      }
                    </div>
                  </div>
                }
                <div class="fields-container case-documents-redesign">
                  @if (loadingDoc) {
                    <app-skeleton-loader
                      [formLoader]="true"
                      [noOfFields]="3"
                    ></app-skeleton-loader>
                  }
                  @if (srFolder && !loadingDoc) {
                    @if (showActions) {
                      <div class="field-control case-doc-type-control">
                        <app-option-field
                          [label]="'CASE.TYPE_OF_DOCUMENT' | translate"
                          [control]="responseForm.get('documentType')!"
                          [options]="documentTypeOptions"
                          [labelKey]="'label'"
                          [valueKey]="'value'"
                          [placeholder]="
                            'CASE.DOCUMENT_TYPE_PLACEHOLDER' | translate
                          "
                          (onSelectionChange)="onDocumentTypeSelection($event)"
                        ></app-option-field>
                      </div>
                    }
                    @if (selectedDocumentConfig) {
                      <div class="field-control case-doc-file-control">
                        @if (showActions) {
                          <label class="field-label !text-dc-navy">
                            {{ "CASE.FILE" | translate }}
                          </label>
                        }
                        <!-- lang === 'en' ? selectedDocumentConfig.nameEn : (selectedDocumentConfig.nameAr || selectedDocumentConfig.nameEn) -->
                        <app-file
                          #fileCmp
                          [title]="'CASE.TYPE_OF_DOCUMENT' | translate"
                          [documentType]="selectedDocumentConfig.nameEn"
                          (folderMissing)="openFolder()"
                          (onUploadRemove)="
                            handelFileEvent(
                              $event,
                              selectedDocumentConfig.nameEn
                            )
                          "
                          [showAction]="showActions"
                          [folder]="srFolder"
                          [allowedDocumentTypes]="srFolder.allowedDocumentTypes"
                          [systemDocuments]="systemDocuments"
                          [documentServiceType]="documentServiceType.MED_CASE"
                          [stampLocationRequirement]="
                            selectedDocumentConfig?.stampLocationRequirement ||
                            'NOT_APPLICABLE'
                          "
                          [documentUploadUserType]="documentUserType"
                        ></app-file>
                      </div>
                    }
                  }
                </div>
              }

              @if (responseSubmitted) {
                <div class="fields-container">
                  <div class="field-control">
                    <app-validation-message
                      [type]="'success'"
                      [content]="{
                        title: ('CASE.RESPONSE_SUBMITTED_TITLE' | translate),
                        message: ('CASE.RESPONSE_SUBMITTED_MSG' | translate),
                      }"
                      [showbutton]="false"
                    ></app-validation-message>
                  </div>
                </div>
              }
            </form>
          </section>

          <!-- Help Section -->
          <section class="border-t border-gray-200 pt-4">
            <h2 class="text-xl font-semibold text-dc-black mb-2 px-2">
              {{ "CASE.NEED_HELP" | translate }}
            </h2>

            <div class="fields-container">
              <div class="field-control">
                <p class="text-dc-black! mb-4! font-semibold">
                  {{ "CASE.HELP_TEXT" | translate }}
                </p>

                <div>
                  <p class="text-dc-black!">
                    <span class="font-semibold">
                      {{ "CASE.NAME" | translate }}:
                    </span>
                    {{ "CASE.CASE_CONTACT_PERSON_NAME" | translate }}
                  </p>
                  <p class="text-dc-black!">
                    <span class="font-semibold">
                      {{ "CASE.PHONE" | translate }}:
                    </span>
                    {{ "CASE.CASE_CONTACT_PERSON_PHONE" | translate }}
                  </p>
                  <p class="text-dc-black!">
                    <span class="font-semibold">
                      {{ "CASE.EMAIL" | translate }}:
                    </span>
                    {{ "CASE.CASE_CONTACT_PERSON_EMAIL" | translate }}
                  </p>
                </div>

                <p class="text-sm text-dc-black! mt-4">
                  {{ "CASE.CONTACT_FOOTER" | translate }}
                  <a
                    href="mailto:info@dubaichambers.com"
                    class="text-dc-navy underline underline-offset-4 font-semibold"
                  >
                    {{ "CASE.CASE_CONTACT_EMAIL" | translate }}
                  </a>
                </p>
              </div>
            </div>
          </section>
        }
      </div>
    </div>
  </div>
  @if (!caseDetailLoading) {
    <div>
      <app-service-progress
        [serviceName]="'CASE.COMMERCIAL_COMPLAINT' | translate"
        [showProgress]="false"
        [showChatWithUs]="this.pageView == 'guest'"
      />
    </div>
  }
</div>
